import { render, staticRenderFns } from "./EditCampaign.vue?vue&type=template&id=60faffe8&scoped=true&"
import script from "./EditCampaign.vue?vue&type=script&lang=js&"
export * from "./EditCampaign.vue?vue&type=script&lang=js&"
import style0 from "./EditCampaign.vue?vue&type=style&index=0&id=60faffe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60faffe8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCardTitle,VExpandTransition,VProgressLinear})
